import React from 'react';
import PropTypes from 'prop-types';
import isArray from 'lodash/isArray';
import InnerHTML from '@Components/InnerHTML';
import { SUPPLIER_INFO_ITEMS } from '@Constants/ElementConstants';

function SupplierRow({ title, info }) {
  return (
    <div className="rx-substance-identification">
      <strong className="u-els-font-family-bold">{title}</strong>
      <InnerHTML tag="div" html={info} />
    </div>
  );
}

function getSupplierRows(databaseId, supplierData) {
  const supplierInfo = [];
  const supplierItems = SUPPLIER_INFO_ITEMS[databaseId] || SUPPLIER_INFO_ITEMS.default;

  supplierItems.forEach((item) => {
    const { name, title } = item;
    const data = supplierData[name];

    if (data) {
      // Use a unique key if possible, fallback to name
      supplierInfo.push(<SupplierRow key={name} title={title} info={isArray(data) ? data.join('; ') : data} />);
    }
  });

  return supplierInfo;
}

function SubstanceSupplierInformation({ substance, database, onToggle }) {
  const { id } = database;
  const { supplierData } = substance;

  // Keyboard accessibility for close button
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      onToggle(e);
    }
  };

  return (
    <div
      id="substance-supplier-information"
      className="substance-results-information u-els-padding-top u-els-font-size-base u-els-line-height-default"
      aria-expanded>
      <div className="sub-menu">
        <i role="button" tabIndex={0} className="sub-menu-close ss-delete" onClick={onToggle} onKeyDown={handleKeyDown} />
        <div className="u-els-font-size-h3">Supplier information</div>
        {getSupplierRows(id, supplierData)}
      </div>
    </div>
  );
}

SubstanceSupplierInformation.propTypes = {
  database: PropTypes.object.isRequired,
  substance: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default SubstanceSupplierInformation;
